import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-auth`
let baseUrl2 = `${httpUrl.host}/gy-apartment`

let api = {
  // 添加子账号
  addAccount: `${baseUrl}/account/add`,

  // 修改子账号
  updateAccount: `${baseUrl}/account/update`,

  // 修改子账号密码
  changePassword: `${baseUrl}/account/changePassword`,

  // 删除子账号
  deleteAccountByCodes: `${baseUrl}/account/deleteByCodes`,

  // 获取单个子账号信息
  getAccountByCode: `${baseUrl}/account/getByCode`,

  // 获取子账号列表
  getAccountList: `${baseUrl}/account/getList`,

  // 获取子账号分页
  getAccountPage: `${baseUrl}/account/getPage`,

  // 获取子账号列表
  getRoleList: `${baseUrl}/role/getList`,

  // 获取住户列表
  getEnterpriseList: `${baseUrl2}/enterpriseInfo/getEnterpriseList`,

  // 获取楼栋数据
  getBuildingList: `${baseUrl2}/homePage/getBuildingList`,

  // 获取人员列表
  getResponsiblePerson: `${baseUrl2}/person/getResponsiblePersonList`,

  // 获取企业管理员列表
  getEnterprisePerson: `${baseUrl2}/person/getList`,

  // 获取人员列表
  getPersonList: `${baseUrl2}/person/getList`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/Account.js